var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { APP_MODE } from "@travel/shared/types";
import { fetcher as fetch, } from "@travel/shared/utils";
import { TRAVEL_API_ROOT } from "../endpoints";
var TRAVEL_PRODUCT_API_KEY_MAP = {
    hotels: "hotels",
    flights: "fly",
    cars: "drive",
};
export function TravelAPI(_a, handle) {
    var _this = this;
    var name = _a.name, product = _a.product, urlInput = _a.url, _b = _a.baseURL, baseURL = _b === void 0 ? TRAVEL_API_ROOT : _b, _c = _a.method, method = _c === void 0 ? "get" : _c, _d = _a.json, json = _d === void 0 ? true : _d, cache = _a.cache, next = _a.next, mutate = _a.mutate, mutateRequest = _a.mutateRequest, mutateOptions = _a.mutateOptions;
    if (handle === void 0) { handle = fetch; }
    var productKey = !product ? "" : TRAVEL_PRODUCT_API_KEY_MAP[product];
    var fetcher = function (request, options, mutateOptions, inputURL) { return __awaiter(_this, void 0, void 0, function () {
        var input, resourceURL, data, mutated, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    input = request;
                    try {
                        input = (mutateRequest === null || mutateRequest === void 0 ? void 0 : mutateRequest(request)) || request;
                    }
                    catch (error) {
                        console.log("TravelAPI(".concat(name, ")->mutateRequest::ERROR"));
                        console.log({
                            request: request,
                            error: error,
                        });
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    resourceURL = inputURL || url(request);
                    return [4 /*yield*/, handle(resourceURL, { method: method, cache: cache, next: next }, input, __assign(__assign({}, options), { sourceCode: "".concat((options === null || options === void 0 ? void 0 : options.sourceCode) || APP_MODE, ":").concat(name, ":fetch"), json: json }))];
                case 2:
                    data = (_a.sent()).data;
                    mutated = data
                        ? (mutate === null || mutate === void 0 ? void 0 : mutate(data, request, mutateOptions, resourceURL)) || data
                        : undefined;
                    result = mutated;
                    if (!(result instanceof Promise)) return [3 /*break*/, 4];
                    return [4 /*yield*/, mutated];
                case 3:
                    result = (_a.sent());
                    _a.label = 4;
                case 4: return [2 /*return*/, (data ? result : undefined)];
                case 5:
                    error_1 = _a.sent();
                    throw error_1;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    fetcher.url = url;
    return fetcher;
    function url(request) {
        return "".concat(baseURL).concat(productKey ? "/".concat(productKey) : "").concat(typeof urlInput === "string" ? urlInput : urlInput(request));
    }
}
